const { SECTIONS_NAME } = require('modules/sections/constants/index.cjs')
const { MODAL_ID } = require('modules/modal/constants/index.cjs')
const { ORDER_MODEL_STATUSES_LABEL } = require('models/daos/order/constants/index.cjs')
const invertObjectUtil = require('packages/src/modules/object/invert/index.js').default

const ROUTE_PATH = {
  // App
  INDEX: '/',
  CONTACT: '/contact',

  // Signup
  SIGNUP: '/signup',
  SIGNIN: '/signin',

  // Articles
  ARTICLES: '/articles',
  ARTICLES_NEW: '/articles/new',
  ARTICLES_NEW_FROM_TEXT: '/articles/new-from-text',
  ARTICLES_EDIT: '/articles/edit',
  ARTICLES_BY_CATEGORY_OR_SLUG: '/articles/:categoryOrSlug',
  ARTICLES_BY_CATEGORY_OR_SLUG_EDIT: '/articles/:categoryOrSlug/edit',

  // Cart
  CART: '/cart',

  // Categories
  CATEGORY_NEW: '/new',
  CATEGORY_EDIT: '/edit',

  // Checkout
  CHECKOUT: '/checkout',

  // Company
  COMPANY: '/company',
  LINKS: '/links',
  LINKS_EDIT: '/links/edit',
  COMPANY_EDIT: '/company/edit',
  COMPANY_BY_SLUG: '/company/:slug',
  ABOUT: '/company/about',
  COMPANY_BY_SLUG_EDIT: '/company/:slug/edit',

  // Home
  HOME: '/',

  // Pages
  PAGES: '/pages',
  PAGES_NEW: '/pages/new',

  // Profile
  PROFILE: '/profile',
  PROFILE_BY_NAME: '/profile/:name',
  PROFILE_BY_NAME_EDIT: '/profile/:name/edit',

  // PromoCode
  PROMO_CODES_NEW: '/promoCodes/new',
  PROMO_CODES_BY_NAME_EDIT: '/promoCodes/:name/edit',

  // Logs
  LOGS: '/logs',
  LOGS_BY_USERNAME_OR_ID: '/logs/:userNameOrId',

  // Motivation
  MOTIVATION: '/motivation',
  MOTIVATION_NEW: '/motivation/new',
  MOTIVATION_EDIT: '/motivation/edit',
  MOTIVATION_BY_CATEGORY_OR_SLUG: '/motivation/:categoryOrSlug',
  MOTIVATION_BY_CATEGORY_OR_SLUG_EDIT: '/motivation/:categoryOrSlug/edit',

  // New
  NEW: '/new',

  // Notifications
  NOTIFICATIONS: '/notifications',

  // Orders
  ORDERS: '/orders',
  ORDERS_BY_CATEGORY_OR_KEY: '/orders/:categoryOrKey',
  ORDERS_BY_CATEGORY_OR_KEY_EDIT: '/orders/:categoryOrKey/edit',
  RESET_PASSWORD: '/reset-password',
  CHANGE_PASSWORD: '/change-password',
  CHANGE_PASSWORD_WITH_TOKEN: '/change-password/:token',

  // Email templates
  EMAIL_TEMPLATES: '/emailTemplates',
  EMAIL_TEMPLATES_NEW: '/emailTemplates/new',
  EMAIL_TEMPLATES_EDIT: '/emailTemplates/edit',
  EMAIL_TEMPLATES_BY_ID: '/emailTemplates/:id',
  EMAIL_TEMPLATES_BY_ID_EDIT: '/emailTemplates/:id/edit',

  // Search
  SEARCH: '/search',
  SEARCH_EXERCISES: '/search/exercises',
  SEARCH_PLANS: '/search/plans',
  SEARCH_WORKOUTS: '/search/workouts',
  SEARCH_BY_CATEGORY: '/search/:category',

  // Store
  STORE: '/store',
  STORE_NEW: '/store/new',
  STORE_EDIT: '/store/edit',
  STORE_CATEGORY_OR_SLUG: '/store/:categoryOrSlug',
  STORE_CATEGORY_OR_SLUG_EDIT: '/store/:categoryOrSlug/edit',

  // Support
  SUPPORT: '/support',
  SUPPORT_EDIT: '/support/edit',
  SUPPORT_BY_SLUG: '/support/:slug',
  SUPPORT_BY_SLUG_EDIT: '/support/:slug/edit',

  // Verify email
  VERIFY_EMAIL: '/verify-email',
  VERIFY_EMAIL_WITH_TOKEN: '/verify-email/:token',

  // App
  APP_DEEP_LINK_OPEN: '/deep-link/open',

  // Coaching
  COACHING: '/coaching',
  COACHING_PAYMENT: '/coaching/payment',
  APP_COACH_INVITATION: '/coach/:id/invitation/:token',

  // Training
  APP: '/app',
  TRACK_CALORIES: '/track-calories',
  CHECK_EXERCISE_FORM: '/check-exercise-form',
  CHECK_EXERCISE_FORM_SLUG: '/check-exercise-form/:id/:slug',
  TOOLS: '/tools',
  TOOLS_CHECK_EXERCISE_FORM: '/tools/check-exercise-form',
  ACCOUNT_EDIT: '/account/edit',
  ACCOUNT: '/account',
  APP_CHALLENGE: '/challenge',
  APP_TERMS: '/terms',
  CAREERS: '/careers',
  CAREERS_ROLE: '/careers/roles/:id',
  CREATOR: '/creators',
  CREATOR_SHORT: '/c',
  CREATOR_LANDING: '/creators/:name/landing',
  CREATOR_PROFILE: '/creators/:name',
  CREATOR_LOGIN: '/creators/login',
  CREATOR_CHAT: '/creators/:name/chat',
  CREATOR_PROFILE_SHORT: '/c/:name',
  CREATOR_WORKOUT: '/creator/:name/plans/:planId/workout/:workoutId',
  FAQ: '/faq',
  PRIVACY: '/privacy',

  EXERCISES_EDIT: '/exercises/:id/edit',
  EXERCISES: '/exercises',
  EXERCISES_WITH_MUSCLE: '/exercises/muscles/:muscle',
  EXERCISES_WITH_EQUIPMENT: '/exercises/equipment/:equipment',
  EXERCISES_WITH_TYPES: '/exercises/types/:type',
  ADD_EXERCISES_LIST: '/exercises/add',

  PLANS_BY_TAG: '/plans/tag/:tag',
  PLAN_BY_ID: '/plans/:id',
  PLAN_BY_ID_SLUG: '/plans/:id/:slug',
  PLAN_WORKOUT_BY_ID_SLUG: '/plans/:planId/:planSlug/workouts/:workoutId/:workoutSlug',
  PLANS: '/plans',

  WORKOUTS_BY_TAG: '/workouts/tag/:tag',
  WORKOUT_SHARED_BY_SHARE_KEY: '/workouts/s/:shareKey',
  WORKOUT_BY_ID_SLUG: '/workouts/:id/:slug',
  START_WORKOUT: '/workouts/:id/:slug/start',
  WORKOUT_COMPLETED: '/workouts/:id/:slug/completed',
  WORKOUT_ACHIEVEMENTS: '/workouts/:id/:slug/achievements',
  WORKOUT_BY_ID: '/workouts/:id',
  WORKOUTS: '/workouts',

  PREMIUM: '/premium',
  PREMIUM_OPEN_LOGIN: '/premium?openLogin=true',
  CREATE_EXERCISE: '/exercises/create',
  REPORT: '/reports/:shareKey',
  ADD_EXERCISE: '/exercises/add/:id',
  VIEW_EXERCISE: '/exercises/:id',
  VIEW_EXERCISE_SLUG: '/exercises/:id/:slug',
  NOT_FOUND: ''
}

const sectionSuffix = '-section'
const searchSuffix = '-search'
const trackCaloriesSuffix = '-track-calories'
const checkExerciseFormSuffix = '-check-exercise-form'
const toolsSuffix = '-tools'
const appSuffix = '-app'
const exerciseSuffix = '-exercise'

const ROUTE_TO_BUNDLE_SUFFIX_VALUE = {
  [ROUTE_PATH.INDEX]: '-home',
  [ROUTE_PATH.CONTACT]: '-contact',

  [ROUTE_PATH.EXERCISES]: '-exercises',
  [ROUTE_PATH.VIEW_EXERCISE]: exerciseSuffix,
  [ROUTE_PATH.VIEW_EXERCISE_SLUG]: exerciseSuffix,

  [ROUTE_PATH.WORKOUTS_BY_TAG]: '-workouts',
  [ROUTE_PATH.WORKOUTS]: '-workouts',
  [ROUTE_PATH.WORKOUT_BY_ID]: '-workout',
  [ROUTE_PATH.WORKOUT_BY_ID_SLUG]: '-workout',

  [ROUTE_PATH.PLANS_BY_TAG]: '-plans',
  [ROUTE_PATH.PLANS]: '-plans',
  [ROUTE_PATH.PLAN_BY_ID]: '-plan',
  [ROUTE_PATH.PLAN_BY_ID_SLUG]: '-plan',
  [ROUTE_PATH.PLAN_WORKOUT_BY_ID_SLUG]: '-workout',

  [ROUTE_PATH.ARTICLES_BY_CATEGORY_OR_SLUG]: '-article',
  [ROUTE_PATH.STORE_CATEGORY_OR_SLUG]: '-product',
  [ROUTE_PATH.MOTIVATION_BY_CATEGORY_OR_SLUG]: '-motivation',

  [ROUTE_PATH.SEARCH]: searchSuffix,
  [ROUTE_PATH.SEARCH_PLANS]: searchSuffix,
  [ROUTE_PATH.SEARCH_WORKOUTS]: searchSuffix,
  [ROUTE_PATH.SEARCH_EXERCISES]: searchSuffix,
  [ROUTE_PATH.SEARCH_BY_CATEGORY]: searchSuffix,

  [ROUTE_PATH.ARTICLES]: sectionSuffix,
  [ROUTE_PATH.COMPANY]: sectionSuffix,
  [ROUTE_PATH.EMAIL_TEMPLATES]: sectionSuffix,
  [ROUTE_PATH.MOTIVATION]: sectionSuffix,
  [ROUTE_PATH.SUPPORT]: sectionSuffix,
  [ROUTE_PATH.APP]: appSuffix,
  [ROUTE_PATH.TRACK_CALORIES]: trackCaloriesSuffix,
  [ROUTE_PATH.CHECK_EXERCISE_FORM]: checkExerciseFormSuffix,
  [ROUTE_PATH.CHECK_EXERCISE_FORM_SLUG]: checkExerciseFormSuffix,
  [ROUTE_PATH.TOOLS]: toolsSuffix,
  [ROUTE_PATH.TOOLS_CHECK_EXERCISE_FORM]: toolsSuffix
}

const BUNDLE_SUFFIX_VALUE_TO_ROUTE = invertObjectUtil(ROUTE_TO_BUNDLE_SUFFIX_VALUE)
const suffixForDev = exerciseSuffix
const routePathSuffixForDev = BUNDLE_SUFFIX_VALUE_TO_ROUTE[exerciseSuffix]

const IS_ANALYZING_BUNDLE = !!process.env.ANALYZE_BUNDLE
let ROUTE_TO_BUNDLE_SUFFIX
if (process.env.NODE_ENV === 'development') {
  ROUTE_TO_BUNDLE_SUFFIX = {
    [routePathSuffixForDev]: suffixForDev
  }
} else if (IS_ANALYZING_BUNDLE) {
  ROUTE_TO_BUNDLE_SUFFIX = {
    [ROUTE_PATH.INDEX]: '-home'
  }
} else {
  ROUTE_TO_BUNDLE_SUFFIX = ROUTE_TO_BUNDLE_SUFFIX_VALUE
}

const ROUTE_BUNDLE_SUFFIX_TO_GLOBAL_KEY = Object
  .keys(ROUTE_TO_BUNDLE_SUFFIX_VALUE)
  .reduce((obj, key) => {
    const value = ROUTE_TO_BUNDLE_SUFFIX_VALUE[key]
    const upperCaseKey = value.slice(1).toUpperCase().replace(/-/g, '_')
    obj[value] = upperCaseKey
    return obj
  }, {})

/**
 * A mapping of route to container.
 * @private
 * @type {Object}
 */
const ROUTE_TO_MODAL_ID = {
  [ROUTE_PATH.CHANGE_PASSWORD]: MODAL_ID.CHANGE_PASSWORD,
  [ROUTE_PATH.CHECKOUT]: MODAL_ID.CHECKOUT,
  [ROUTE_PATH.RESET_PASSWORD]: MODAL_ID.RESET_PASSWORD,
  [ROUTE_PATH.SIGNIN]: MODAL_ID.SIGNIN,
  [ROUTE_PATH.SIGNUP]: MODAL_ID.SIGNIN,
  [ROUTE_PATH.VERIFY_EMAIL]: MODAL_ID.VERIFY_EMAIL
}

const ROUTE_PATHS_WITHOUT_CATEGORIES = [
  ROUTE_PATH.CART,
  ROUTE_PATH.CHANGE_PASSWORD,
  ROUTE_PATH.COACHING,
  ROUTE_PATH.CHECKOUT,
  ROUTE_PATH.NOTIFICATIONS,
  ROUTE_PATH.PROFILE,
  ROUTE_PATH.RESET_PASSWORD,
  ROUTE_PATH.SIGNIN,
  ROUTE_PATH.SIGNUP,
  ROUTE_PATH.VERIFY_EMAIL,
  ROUTE_PATH.LINKS
]
const ROUTE_PATHS_WITH_CATEGORIES = [
  ROUTE_PATH.SEARCH_BY_CATEGORY,
  ROUTE_PATH.SEARCH_PLANS,
  ROUTE_PATH.SEARCH_EXERCISES,
  ROUTE_PATH.SEARCH_WORKOUTS
]

const ROUTE_PATHS_WITHOUT_AUTHOR_ROW = [
  ROUTE_PATH.LINKS
]

const ROUTE_PATHS_WITHOUT_SHARE = [
  ROUTE_PATH.LINKS
]

const ROUTE_PATHS_TO_PATH_DOMAIN_MAP_VALUE = [
  ROUTE_PATH.LINKS
]

const ROUTE_PATHS_WITHOUT_SUB_NAV_BAR = [
  ...ROUTE_PATHS_WITHOUT_CATEGORIES,
  ROUTE_PATH.HOME,
  ROUTE_PATH.CREATOR,
  ROUTE_PATH.CREATOR_LOGIN,
  ROUTE_PATH.CREATOR_CHAT,
  ROUTE_PATH.VIEW_EXERCISE,
  ROUTE_PATH.ADD_EXERCISE,
  ROUTE_PATH.ADD_EXERCISES_LIST,
  ROUTE_PATH.START_WORKOUT,
  ROUTE_PATH.CREATOR_WORKOUT,
  ROUTE_PATH.START_WORKOUT,
  ROUTE_PATH.WORKOUT_ACHIEVEMENTS,
  ROUTE_PATH.WORKOUT_COMPLETED
]

const ROUTE_PATHS_WITHOUT_GYMAHOLIC_HEADER = [
  ROUTE_PATH.CREATOR,
  ROUTE_PATH.CREATOR_LOGIN,
  ROUTE_PATH.CREATOR_CHAT,
  ROUTE_PATH.CREATOR_LANDING,
  ROUTE_PATH.CREATOR_WORKOUT,
  ROUTE_PATH.START_WORKOUT,
  ROUTE_PATH.WORKOUT_COMPLETED,
  ROUTE_PATH.WORKOUT_ACHIEVEMENTS,
  ROUTE_PATH.ADD_EXERCISES_LIST,
  ROUTE_PATH.ADD_EXERCISE
]

const ROUTE_PATHS_WITHOUT_SCROLL_TO_TOP = [
  ROUTE_PATH.CREATOR,
  ROUTE_PATH.CREATOR_WORKOUT,
  ROUTE_PATH.CREATOR_LOGIN
]

const ROUTE_PATH_WITH_CUSTOM_SIDEBAR = {
  CART: ROUTE_PATH.CART,
  CHECKOUT: ROUTE_PATH.CHECKOUT,
  ORDERS: ROUTE_PATH.ORDERS
}

const ROUTE_PATHS_WITHOUT_SIDEBAR = [
  ROUTE_PATH.NOTIFICATIONS,
  ROUTE_PATH.ACCOUNT,
  ROUTE_PATH.APP_CHALLENGE,
  ROUTE_PATH.COACHING,
  ROUTE_PATH.COACHING_PAYMENT,
  ROUTE_PATH.CREATOR,
  ROUTE_PATH.CREATOR_LOGIN,
  ROUTE_PATH.CREATOR_SHORT
]

/**
 * A mapping of key to route.
 * @type {Object}
 */
const ROUTE = {
  // Home
  [ROUTE_PATH.INDEX]: {
    end: true,
    isCollection: true,
    path: ROUTE_PATH.INDEX,
    section: SECTIONS_NAME.HOME
  },
  [ROUTE_PATH.CONTACT]: {
    end: true,
    path: ROUTE_PATH.CONTACT
  },

  // Articles
  [ROUTE_PATH.ARTICLES]: {
    end: true,
    isCollection: true,
    path: ROUTE_PATH.ARTICLES,
    section: SECTIONS_NAME.ARTICLES
  },
  [ROUTE_PATH.ARTICLES_NEW]: {
    end: true,
    path: ROUTE_PATH.ARTICLES_NEW,
    section: SECTIONS_NAME.ARTICLES
  },
  [ROUTE_PATH.ARTICLES_NEW_FROM_TEXT]: {
    end: true,
    path: ROUTE_PATH.ARTICLES_NEW_FROM_TEXT,
    section: SECTIONS_NAME.ARTICLES
  },
  [ROUTE_PATH.ARTICLES_EDIT]: {
    end: true,
    path: ROUTE_PATH.ARTICLES_EDIT,
    section: SECTIONS_NAME.ARTICLES
  },
  [ROUTE_PATH.ARTICLES_BY_CATEGORY_OR_SLUG]: {
    end: true,
    getData: getCategoryOrSlugData,
    path: ROUTE_PATH.ARTICLES_BY_CATEGORY_OR_SLUG,
    section: SECTIONS_NAME.ARTICLES
  },
  [ROUTE_PATH.ARTICLES_BY_CATEGORY_OR_SLUG_EDIT]: {
    end: true,
    getData: getCategoryOrSlugData,
    path: ROUTE_PATH.ARTICLES_BY_CATEGORY_OR_SLUG_EDIT,
    section: SECTIONS_NAME.ARTICLES
  },

  // Cart
  [ROUTE_PATH.CART]: {
    end: true,
    path: ROUTE_PATH.CART
  },

  // Categories
  [ROUTE_PATH.CATEGORY_NEW]: {
    end: true,
    path: ROUTE_PATH.CATEGORY_NEW
  },
  [ROUTE_PATH.CATEGORY_EDIT]: {
    end: true,
    isInstance: true,
    path: ROUTE_PATH.CATEGORY_EDIT
  },

  // Checkout
  [ROUTE_PATH.CHECKOUT]: {
    end: true,
    path: ROUTE_PATH.CHECKOUT
  },

  // Company
  [ROUTE_PATH.COMPANY]: {
    end: true,
    isInstance: true,
    path: ROUTE_PATH.COMPANY,
    section: SECTIONS_NAME.PAGES,
    getData: () => (
      {
        params: {
          category: 'company'
        }
      }
    )
  },
  [ROUTE_PATH.COMPANY_EDIT]: {
    end: true,
    isInstance: true,
    path: ROUTE_PATH.COMPANY_EDIT,
    section: SECTIONS_NAME.PAGES,
    getData: () => (
      {
        params: {
          category: 'company'
        }
      }
    )
  },
  [ROUTE_PATH.COMPANY_BY_SLUG]: {
    end: true,
    getData: () => (
      {
        params: {
          category: 'company'
        }
      }
    ),
    isInstance: true,
    path: ROUTE_PATH.COMPANY_BY_SLUG,
    section: SECTIONS_NAME.PAGES
  },
  [ROUTE_PATH.COMPANY_BY_SLUG_EDIT]: {
    end: true,
    getData: () => (
      {
        params: {
          category: 'company'
        }
      }
    ),
    isInstance: true,
    path: ROUTE_PATH.COMPANY_BY_SLUG_EDIT,
    section: SECTIONS_NAME.PAGES
  },

  // Pages
  [ROUTE_PATH.PAGES]: {
    end: true,
    isCollection: true,
    path: ROUTE_PATH.PAGES,
    section: SECTIONS_NAME.PAGES
  },
  [ROUTE_PATH.PAGES_NEW]: {
    end: true,
    path: ROUTE_PATH.PAGES_NEW,
    section: SECTIONS_NAME.PAGES
  },

  // Profile
  [ROUTE_PATH.PROFILE]: {
    end: true,
    isInstance: true,
    path: ROUTE_PATH.PROFILE,
    section: SECTIONS_NAME.USERS
  },
  [ROUTE_PATH.PROFILE_BY_NAME]: {
    end: true,
    isInstance: true,
    path: ROUTE_PATH.PROFILE_BY_NAME,
    section: SECTIONS_NAME.USERS
  },
  [ROUTE_PATH.PROFILE_BY_NAME_EDIT]: {
    end: true,
    isInstance: true,
    path: ROUTE_PATH.PROFILE_BY_NAME_EDIT,
    section: SECTIONS_NAME.USERS
  },

  // PromoCode
  [ROUTE_PATH.PROMO_CODES_NEW]: {
    end: true,
    path: ROUTE_PATH.PROMO_CODES_NEW,
    section: SECTIONS_NAME.PROMO_CODES
  },
  [ROUTE_PATH.PROMO_CODES_BY_NAME_EDIT]: {
    end: true,
    isInstance: true,
    path: ROUTE_PATH.PROMO_CODES_BY_NAME_EDIT,
    section: SECTIONS_NAME.PROMO_CODES
  },

  // Logs
  [ROUTE_PATH.LOGS]: {
    end: true,
    isCollection: true,
    path: ROUTE_PATH.LOGS,
    section: SECTIONS_NAME.LOGS
  },
  [ROUTE_PATH.LOGS_BY_USERNAME_OR_ID]: {
    end: true,
    getData: getLogsData,
    path: ROUTE_PATH.LOGS_BY_USERNAME_OR_ID,
    section: SECTIONS_NAME.LOGS
  },

  // Motivation
  [ROUTE_PATH.MOTIVATION]: {
    end: true,
    isCollection: true,
    path: ROUTE_PATH.MOTIVATION,
    section: SECTIONS_NAME.MOTIVATION
  },
  [ROUTE_PATH.MOTIVATION_NEW]: {
    end: true,
    path: ROUTE_PATH.MOTIVATION_NEW,
    section: SECTIONS_NAME.MOTIVATION
  },
  [ROUTE_PATH.MOTIVATION_EDIT]: {
    end: true,
    isInstance: true,
    path: ROUTE_PATH.MOTIVATION_EDIT,
    section: SECTIONS_NAME.MOTIVATION
  },
  [ROUTE_PATH.MOTIVATION_BY_CATEGORY_OR_SLUG]: {
    end: true,
    getData: getCategoryOrSlugData,
    path: ROUTE_PATH.MOTIVATION_BY_CATEGORY_OR_SLUG,
    section: SECTIONS_NAME.MOTIVATION
  },
  [ROUTE_PATH.MOTIVATION_BY_CATEGORY_OR_SLUG_EDIT]: {
    end: true,
    getData: getCategoryOrSlugData,
    path: ROUTE_PATH.MOTIVATION_BY_CATEGORY_OR_SLUG_EDIT,
    section: SECTIONS_NAME.MOTIVATION
  },

  // New
  [ROUTE_PATH.NEW]: {
    end: true,
    path: ROUTE_PATH.NEW
  },

  // Notifications
  [ROUTE_PATH.NOTIFICATIONS]: {
    end: true,
    isCollection: true,
    path: ROUTE_PATH.NOTIFICATIONS,
    section: SECTIONS_NAME.NOTIFICATIONS
  },

  // Orders
  [ROUTE_PATH.ORDERS]: {
    end: true,
    isCollection: true,
    path: ROUTE_PATH.ORDERS,
    section: SECTIONS_NAME.ORDERS
  },
  [ROUTE_PATH.ORDERS_BY_CATEGORY_OR_KEY]: {
    end: true,
    getData: getOrdersData,
    path: ROUTE_PATH.ORDERS_BY_CATEGORY_OR_KEY,
    section: SECTIONS_NAME.ORDERS
  },
  [ROUTE_PATH.ORDERS_BY_CATEGORY_OR_KEY_EDIT]: {
    end: true,
    isInstance: true,
    getData: getOrdersData,
    path: ROUTE_PATH.ORDERS_BY_CATEGORY_OR_KEY_EDIT,
    section: SECTIONS_NAME.ORDERS
  },
  [ROUTE_PATH.CAREERS]: {
    end: true,
    path: ROUTE_PATH.CAREERS
  },
  [ROUTE_PATH.CAREERS_ROLE]: {
    end: true,
    path: ROUTE_PATH.CAREERS_ROLE,
    isApp: true
  },
  [ROUTE_PATH.CREATOR_PROFILE]: {
    end: true,
    path: ROUTE_PATH.CREATOR_PROFILE,
    isApp: true
  },
  [ROUTE_PATH.CREATOR_CHAT]: {
    end: true,
    path: ROUTE_PATH.CREATOR_CHAT,
    isApp: true
  },
  [ROUTE_PATH.CREATOR]: {
    end: true,
    path: ROUTE_PATH.CREATOR,
    isApp: true
  },
  [ROUTE_PATH.CREATOR_LOGIN]: {
    end: true,
    path: ROUTE_PATH.CREATOR_LOGIN,
    isApp: true
  },
  [ROUTE_PATH.CREATOR_PROFILE_SHORT]: {
    end: true,
    path: ROUTE_PATH.CREATOR_PROFILE_SHORT,
    isApp: true
  },
  [ROUTE_PATH.CREATOR_LANDING]: {
    end: true,
    path: ROUTE_PATH.CREATOR_LANDING,
    isApp: true
  },
  [ROUTE_PATH.CREATOR_WORKOUT]: {
    end: true,
    path: ROUTE_PATH.CREATOR_WORKOUT,
    isApp: true
  },
  [ROUTE_PATH.EXERCISES_WITH_MUSCLE]: {
    end: true,
    path: ROUTE_PATH.EXERCISES_WITH_MUSCLE,
    isApp: true
  },
  [ROUTE_PATH.EXERCISES_WITH_EQUIPMENT]: {
    end: true,
    path: ROUTE_PATH.EXERCISES_WITH_EQUIPMENT,
    isApp: true
  },
  [ROUTE_PATH.EXERCISES_WITH_TYPES]: {
    end: true,
    path: ROUTE_PATH.EXERCISES_WITH_TYPES,
    isApp: true
  },
  [ROUTE_PATH.ADD_EXERCISES_LIST]: {
    end: true,
    path: ROUTE_PATH.ADD_EXERCISES_LIST,
    isApp: true
  },
  [ROUTE_PATH.CREATE_EXERCISE]: {
    end: true,
    path: ROUTE_PATH.CREATE_EXERCISE,
    isApp: true
  },
  [ROUTE_PATH.REPORT]: {
    end: true,
    path: ROUTE_PATH.REPORT,
    isApp: true
  },

  [ROUTE_PATH.ADD_EXERCISE]: {
    end: true,
    path: ROUTE_PATH.ADD_EXERCISE,
    isApp: true
  },

  [ROUTE_PATH.VIEW_EXERCISE]: {
    end: true,
    path: ROUTE_PATH.VIEW_EXERCISE,
    isApp: true
  },
  [ROUTE_PATH.VIEW_EXERCISE_SLUG]: {
    end: true,
    path: ROUTE_PATH.VIEW_EXERCISE_SLUG,
    isApp: true
  },
  [ROUTE_PATH.RESET_PASSWORD]: {
    end: true,
    path: ROUTE_PATH.RESET_PASSWORD
  },
  [ROUTE_PATH.CHANGE_PASSWORD]: {
    end: true,
    path: ROUTE_PATH.CHANGE_PASSWORD
  },
  [ROUTE_PATH.CHANGE_PASSWORD_WITH_TOKEN]: {
    end: true,
    path: ROUTE_PATH.CHANGE_PASSWORD_WITH_TOKEN
  },

  // Email templates
  [ROUTE_PATH.EMAIL_TEMPLATES]: {
    end: true,
    isCollection: true,
    path: ROUTE_PATH.EMAIL_TEMPLATES,
    section: SECTIONS_NAME.EMAIL_TEMPLATES
  },
  [ROUTE_PATH.EMAIL_TEMPLATES_NEW]: {
    end: true,
    path: ROUTE_PATH.EMAIL_TEMPLATES_NEW,
    section: SECTIONS_NAME.EMAIL_TEMPLATES
  },
  [ROUTE_PATH.EMAIL_TEMPLATES_EDIT]: {
    end: true,
    isInstance: true,
    path: ROUTE_PATH.EMAIL_TEMPLATES_EDIT,
    section: SECTIONS_NAME.EMAIL_TEMPLATES
  },
  [ROUTE_PATH.EMAIL_TEMPLATES_BY_ID]: {
    end: true,
    isInstance: true,
    path: ROUTE_PATH.EMAIL_TEMPLATES_BY_ID,
    section: SECTIONS_NAME.EMAIL_TEMPLATES
  },
  [ROUTE_PATH.EMAIL_TEMPLATES_BY_ID_EDIT]: {
    end: true,
    isInstance: true,
    path: ROUTE_PATH.EMAIL_TEMPLATES_BY_ID_EDIT,
    section: SECTIONS_NAME.EMAIL_TEMPLATES
  },

  // Search
  [ROUTE_PATH.SEARCH]: {
    end: true,
    isCollection: true,
    path: ROUTE_PATH.SEARCH,
    section: SECTIONS_NAME.SEARCH
  },
  [ROUTE_PATH.SEARCH_EXERCISES]: {
    end: true,
    isCollection: true,
    path: ROUTE_PATH.SEARCH_EXERCISES,
    section: SECTIONS_NAME.SEARCH
  },
  [ROUTE_PATH.SEARCH_PLANS]: {
    end: true,
    isCollection: true,
    path: ROUTE_PATH.SEARCH_PLANS,
    section: SECTIONS_NAME.SEARCH
  },
  [ROUTE_PATH.SEARCH_WORKOUTS]: {
    end: true,
    isCollection: true,
    path: ROUTE_PATH.SEARCH_WORKOUTS,
    section: SECTIONS_NAME.SEARCH
  },
  [ROUTE_PATH.SEARCH_BY_CATEGORY]: {
    end: true,
    isCollection: true,
    path: ROUTE_PATH.SEARCH_BY_CATEGORY,
    section: SECTIONS_NAME.SEARCH
  },

  // Signup
  [ROUTE_PATH.SIGNUP]: {
    end: true,
    path: ROUTE_PATH.SIGNUP,
    section: SECTIONS_NAME.USERS
  },
  [ROUTE_PATH.SIGNIN]: {
    end: true,
    path: ROUTE_PATH.SIGNIN,
    section: SECTIONS_NAME.USERS
  },

  // Store
  [ROUTE_PATH.STORE]: {
    end: true,
    isCollection: true,
    path: ROUTE_PATH.STORE,
    section: SECTIONS_NAME.STORE
  },
  [ROUTE_PATH.STORE_NEW]: {
    end: true,
    path: ROUTE_PATH.STORE_NEW,
    section: SECTIONS_NAME.STORE
  },
  [ROUTE_PATH.STORE_EDIT]: {
    end: true,
    isInstance: true,
    path: ROUTE_PATH.STORE_EDIT,
    section: SECTIONS_NAME.STORE
  },
  [ROUTE_PATH.STORE_CATEGORY_OR_SLUG]: {
    end: true,
    getData: getCategoryOrSlugData,
    path: ROUTE_PATH.STORE_CATEGORY_OR_SLUG,
    section: SECTIONS_NAME.STORE
  },
  [ROUTE_PATH.STORE_CATEGORY_OR_SLUG_EDIT]: {
    end: true,
    getData: getCategoryOrSlugData,
    isInstance: true,
    path: ROUTE_PATH.STORE_CATEGORY_OR_SLUG_EDIT,
    section: SECTIONS_NAME.STORE
  },

  // Support
  [ROUTE_PATH.SUPPORT]: {
    end: true,
    getData: () => (
      {
        params: {
          category: 'support'
        }
      }
    ),
    isCollection: true,
    path: ROUTE_PATH.SUPPORT,
    section: SECTIONS_NAME.PAGES
  },
  [ROUTE_PATH.SUPPORT_EDIT]: {
    end: true,
    getData: () => (
      {
        params: {
          category: 'support'
        }
      }
    ),
    isInstance: true,
    path: ROUTE_PATH.SUPPORT_EDIT,
    section: SECTIONS_NAME.PAGES
  },
  [ROUTE_PATH.LINKS]: {
    end: true,
    isInstance: true,
    path: ROUTE_PATH.LINKS,
    section: SECTIONS_NAME.PAGES
  },
  [ROUTE_PATH.LINKS_EDIT]: {
    end: true,
    isInstance: true,
    path: ROUTE_PATH.LINKS_EDIT,
    section: SECTIONS_NAME.PAGES
  },
  [ROUTE_PATH.SUPPORT_BY_SLUG]: {
    end: true,
    getData: () => (
      {
        params: {
          category: 'support'
        }
      }
    ),
    isInstance: true,
    path: ROUTE_PATH.SUPPORT_BY_SLUG,
    section: SECTIONS_NAME.PAGES
  },
  [ROUTE_PATH.SUPPORT_BY_SLUG_EDIT]: {
    end: true,
    getData: () => (
      {
        params: {
          category: 'support'
        }
      }
    ),
    isInstance: true,
    path: ROUTE_PATH.SUPPORT_BY_SLUG_EDIT,
    section: SECTIONS_NAME.PAGES
  },

  // Verify email
  [ROUTE_PATH.VERIFY_EMAIL]: {
    end: true,
    path: ROUTE_PATH.VERIFY_EMAIL
  },
  [ROUTE_PATH.VERIFY_EMAIL_WITH_TOKEN]: {
    end: true,
    path: ROUTE_PATH.VERIFY_EMAIL_WITH_TOKEN
  },

  // Training
  [ROUTE_PATH.APP]: {
    end: true,
    path: ROUTE_PATH.APP,
    isApp: true
  },
  [ROUTE_PATH.TRACK_CALORIES]: {
    end: true,
    path: ROUTE_PATH.TRACK_CALORIES,
    isApp: true
  },
  [ROUTE_PATH.CHECK_EXERCISE_FORM]: {
    end: true,
    path: ROUTE_PATH.CHECK_EXERCISE_FORM,
    isApp: true
  },
  [ROUTE_PATH.CHECK_EXERCISE_FORM_SLUG]: {
    end: true,
    path: ROUTE_PATH.CHECK_EXERCISE_FORM_SLUG,
    isApp: true
  },
  [ROUTE_PATH.TOOLS]: {
    end: true,
    path: ROUTE_PATH.TOOLS,
    isApp: true
  },
  [ROUTE_PATH.TOOLS_CHECK_EXERCISE_FORM]: {
    end: true,
    path: ROUTE_PATH.TOOLS_CHECK_EXERCISE_FORM,
    isApp: true
  },
  [ROUTE_PATH.ACCOUNT_EDIT]: {
    end: true,
    path: ROUTE_PATH.ACCOUNT_EDIT,
    isApp: true
  },
  [ROUTE_PATH.ACCOUNT]: {
    end: true,
    path: ROUTE_PATH.ACCOUNT,
    isApp: true
  },
  [ROUTE_PATH.APP_TERMS]: {
    end: true,
    path: ROUTE_PATH.APP_TERMS,
    isApp: true
  },
  [ROUTE_PATH.APP_CHALLENGE]: {
    end: true,
    path: ROUTE_PATH.APP_CHALLENGE,
    isApp: true
  },
  [ROUTE_PATH.FAQ]: {
    end: true,
    path: ROUTE_PATH.FAQ,
    isApp: true
  },
  [ROUTE_PATH.PRIVACY]: {
    end: true,
    path: ROUTE_PATH.PRIVACY,
    isApp: true
  },
  [ROUTE_PATH.PREMIUM]: {
    end: true,
    path: ROUTE_PATH.PREMIUM,
    isApp: true
  },
  [ROUTE_PATH.APP_DEEP_LINK_OPEN]: {
    end: true,
    isApp: true,
    path: ROUTE_PATH.APP_DEEP_LINK_OPEN
  },
  [ROUTE_PATH.COACHING]: {
    end: true,
    isApp: true,
    path: ROUTE_PATH.COACHING
  },
  [ROUTE_PATH.COACHING_PAYMENT]: {
    end: true,
    isApp: true,
    path: ROUTE_PATH.COACHING_PAYMENT
  },
  [ROUTE_PATH.APP_COACH_INVITATION]: {
    end: true,
    isApp: true,
    path: ROUTE_PATH.APP_COACH_INVITATION
  },
  [ROUTE_PATH.EXERCISES_EDIT]: {
    end: true,
    isApp: true,
    isInstance: true,
    path: ROUTE_PATH.EXERCISES_EDIT,
    section: SECTIONS_NAME.EXERCISES
  },
  [ROUTE_PATH.EXERCISES]: {
    end: true,
    isApp: true,
    path: ROUTE_PATH.EXERCISES
  },

  [ROUTE_PATH.PLANS_BY_TAG]: {
    end: true,
    isApp: true,
    isCollection: true,
    path: ROUTE_PATH.PLANS_BY_TAG
  },
  [ROUTE_PATH.PLANS]: {
    end: true,
    isApp: true,
    isCollection: true,
    path: ROUTE_PATH.PLANS
  },
  [ROUTE_PATH.PLAN_BY_ID]: {
    end: true,
    isApp: true,
    isInstance: true,
    path: ROUTE_PATH.PLAN_BY_ID
  },
  [ROUTE_PATH.PLAN_BY_ID_SLUG]: {
    end: true,
    isApp: true,
    isInstance: true,
    path: ROUTE_PATH.PLAN_BY_ID_SLUG
  },
  [ROUTE_PATH.PLAN_WORKOUT_BY_ID_SLUG]: {
    end: true,
    isApp: true,
    isInstance: true,
    path: ROUTE_PATH.PLAN_WORKOUT_BY_ID_SLUG
  },

  [ROUTE_PATH.START_WORKOUT]: {
    end: true,
    isApp: true,
    path: ROUTE_PATH.START_WORKOUT
  },

  [ROUTE_PATH.WORKOUTS_BY_TAG]: {
    end: true,
    isApp: true,
    isCollection: true,
    path: ROUTE_PATH.WORKOUTS_BY_TAG
  },
  [ROUTE_PATH.WORKOUT_SHARED_BY_SHARE_KEY]: {
    end: true,
    isApp: true,
    isInstance: true,
    path: ROUTE_PATH.WORKOUT_SHARED_BY_SHARE_KEY
  },
  [ROUTE_PATH.WORKOUT_BY_ID_SLUG]: {
    end: true,
    isApp: true,
    path: ROUTE_PATH.WORKOUT_BY_ID_SLUG
  },
  [ROUTE_PATH.WORKOUT_COMPLETED]: {
    end: true,
    isApp: true,
    path: ROUTE_PATH.WORKOUT_COMPLETED
  },
  [ROUTE_PATH.WORKOUT_ACHIEVEMENTS]: {
    end: true,
    isApp: true,
    path: ROUTE_PATH.WORKOUT_ACHIEVEMENTS
  },
  [ROUTE_PATH.WORKOUT_BY_ID]: {
    end: true,
    isApp: true,
    isInstance: true,
    path: ROUTE_PATH.WORKOUT_BY_ID
  },
  [ROUTE_PATH.WORKOUTS]: {
    end: true,
    isApp: true,
    isCollection: true,
    path: ROUTE_PATH.WORKOUTS
  },

  // Not Found
  [ROUTE_PATH.NOT_FOUND]: {}
}

const APP_ROUTES = Object
  .values(ROUTE)
  .filter((route) => route.isApp)
  .map(route => route.path)

/**
 * Removes the ending `/new` or `/edit` from the url.
 * @param  {string} pathname
 * @returns {string}
 */
function removeEndingNewEditFromUrl (pathname) {
  return pathname.replace(/\/(edit|new)$/, '')
}

function getCategoryOrSlugData (match) {
  let { pathname } = match
  pathname = removeEndingNewEditFromUrl(pathname)
  const categoryOrSlug = pathname.slice(pathname.lastIndexOf('/') + 1)
  if (categoryOrSlug.includes('-')) {
    return {
      params: {
        slug: categoryOrSlug
      },
      isInstance: true
    }
  }
  return {
    params: {
      category: categoryOrSlug
    },
    isCollection: true
  }
}

function getLogsData (match) {
  let { pathname } = match
  pathname = removeEndingNewEditFromUrl(pathname)
  const usernameOrId = pathname.slice(pathname.lastIndexOf('/') + 1)
  if (!isNaN(usernameOrId)) {
    return {
      params: {
        id: usernameOrId
      },
      isInstance: true
    }
  }
  return {
    params: {
      user: usernameOrId
    },
    isCollection: true
  }
}

function getOrdersData (match) {
  let { pathname } = match
  pathname = removeEndingNewEditFromUrl(pathname)
  const categoryOrKey = pathname.slice(pathname.lastIndexOf('/') + 1)
  if (ORDER_MODEL_STATUSES_LABEL.includes(categoryOrKey)) {
    return {
      params: {
        category: categoryOrKey
      },
      isCollection: true
    }
  }
  return {
    params: {
      key: categoryOrKey
    },
    isInstance: true
  }
}

module.exports = {
  APP_ROUTES,
  ROUTE,
  ROUTE_TO_BUNDLE_SUFFIX,
  ROUTE_BUNDLE_SUFFIX_TO_GLOBAL_KEY,
  ROUTE_PATH,
  ROUTE_PATHS_WITHOUT_SUB_NAV_BAR,
  ROUTE_PATHS_WITH_CATEGORIES,
  ROUTE_PATHS_WITHOUT_CATEGORIES,
  ROUTE_PATHS_WITHOUT_AUTHOR_ROW,
  ROUTE_PATHS_TO_PATH_DOMAIN_MAP_VALUE,
  ROUTE_PATHS_WITHOUT_SHARE,
  ROUTE_PATH_WITH_CUSTOM_SIDEBAR,
  ROUTE_PATHS_WITHOUT_SIDEBAR,
  ROUTE_TO_MODAL_ID,
  ROUTE_PATHS_WITHOUT_GYMAHOLIC_HEADER,
  ROUTE_PATHS_WITHOUT_SCROLL_TO_TOP
}
